import { useDailyRosterStore } from '@/stores';
import { ROUTE_PATHS } from './paths';

// Page title mapping for different routes
export const PAGE_TITLES: Record<string, string> = {
  [ROUTE_PATHS.DASHBOARD]: 'Dashboard',
  [ROUTE_PATHS.DAILY_ROSTER]: 'Daily Roster Management',
  [ROUTE_PATHS.INSTRUCTOR_ROSTER_LIST]: 'Instructor Roster Management',
  [ROUTE_PATHS.ADD_LESSON]: 'Add Lesson',
  [ROUTE_PATHS.TRANSPORT_ROSTER]: 'Transport Roster Management',
  [ROUTE_PATHS.LESSON_ENTRY]: 'Lesson Entry/Edit',
  [ROUTE_PATHS.HOTEL_AGENT_MANAGER_ALL]: 'Hotel/Agent Manager',
  [ROUTE_PATHS.HOTEL_AGENT_MANAGER_ADD]: 'Add Hotel/Agent',
  [ROUTE_PATHS.HOTEL_AGENT_MANAGER_COMMISSION_RATE]:
    'AGENT/HOTEL COMMISSION RATE MANAGER',
  [ROUTE_PATHS.BOOKING_MANAGER_ALL_BOOKINGS]: 'Booking Manager',
  [ROUTE_PATHS.BOOKING_MANAGER_BOOKING_USERS]: 'Booking Users',
  [ROUTE_PATHS.BOOKING_MANAGER_BOOKING_USERS_LIST]: 'Booking Users List',
  [ROUTE_PATHS.BOOKING_MANAGER_DETAILS]: 'Booking Details',
  [ROUTE_PATHS.INSTRUCTOR_MANAGER_LIST]: 'Instructor Manager',
  [ROUTE_PATHS.INSTRUCTOR_MANAGER_ADD]: 'Add Instructor',
  [ROUTE_PATHS.INSTRUCTOR_MANAGER_PAY_RATE]: 'INSTRUCTOR PAY RATE MANAGEMENT',
  [ROUTE_PATHS.STAFF_MANAGER_LIST]: 'Staff Manager',
  [ROUTE_PATHS.STAFF_MANAGER_ADD]: 'Add Staff Manager',
  [ROUTE_PATHS.STAFF_MANAGER_REPORT]: 'Staff Manager Report',
  [ROUTE_PATHS.BOOKING_MANAGER_BROADCAST_MANAGER]: 'Broadcast Manager',
  [ROUTE_PATHS.SERVICE_MANAGER_ALL]: 'Service Manager',
  [ROUTE_PATHS.SERVICE_MANAGER_ADD]: 'Add/Edit Service',
  [ROUTE_PATHS.MOUNTAIN_MANAGER_ALL]: 'Mountain Manager',
  [ROUTE_PATHS.MOUNTAIN_MANAGER_ADD]: 'Add/Edit Mountain',
  [ROUTE_PATHS.TRANSPORT_MANAGER_ALL]: 'Transport Manager',
  [ROUTE_PATHS.TRANSPORT_MANAGER_ADD]: 'Add/Edit Transport',
  [ROUTE_PATHS.ADMIN_USERS_MANAGER_LIST]: 'Admin Users Manager',
  [ROUTE_PATHS.ADMIN_USERS_MANAGER_ADD]: 'Add/Edit Admin User',
  [ROUTE_PATHS.DIET_MANAGER_LIST]: 'Diet Manager',
  [ROUTE_PATHS.DIET_MANAGER_ADD]: 'Add/Edit Diet',
  [ROUTE_PATHS.CONFIGURATION]: 'Configuration',
  [ROUTE_PATHS.CONFIGURATION_ADD]: 'Add/Edit Configuration',
  [ROUTE_PATHS.CHANGE_PASSWORD]: 'Change Password',
  [ROUTE_PATHS.EDIT_PROFILE]: 'Edit Profile',

  [ROUTE_PATHS.REPORT_MANAGER_INSTRUCTOR_REPORT]: 'Instructor Report',
  [ROUTE_PATHS.REPORT_MANAGER_FINANCIAL_REPORT]: 'Financial Report',
  [ROUTE_PATHS.REPORT_MANAGER_HOTEL_AGENTS_REPORT]: 'Hotel/Agents Report',
  [ROUTE_PATHS.REPORT_MANAGER_MOUNTAIN_PARTICIPANT_PARTY]:
    'Mountain Participant Report',
  [ROUTE_PATHS.REPORT_MANAGER_MOUNTAIN_FINANCIAL_REPORT]:
    'Mountain Financial Report',
  [ROUTE_PATHS.REPORT_MANAGER_GROUP_LESSON_REPORT]: 'Group Lesson Report',
  [ROUTE_PATHS.CHEAT_SHEET_LIST]: 'Cheat Sheet List',
  [ROUTE_PATHS.PARTICIPANTS_LIST]: 'Participants List'
} as const;

/**
 * Get page title based on current route pathname
 * @param pathname - The current route pathname
 * @returns The appropriate page title
 */
export const getPageTitle = (pathname: string): string => {
  // Check for exact match first
  if (PAGE_TITLES[pathname]) {
    if (pathname === ROUTE_PATHS.DAILY_ROSTER) {
      const { selectedType } = useDailyRosterStore.getState();
      if (selectedType === 'Month') {
        return 'Monthly Roster Management';
      } else {
        return 'Daily Roster Management';
      }
    }
    return PAGE_TITLES[pathname];
  }

  // if(url.split("/").slice(0, 3).join("/"))

  // Check for dynamic routes (with IDs)
  const pathSegments = pathname.split('/');
  const basePath = pathSegments.slice(0, -1).join('/');

  if (PAGE_TITLES[basePath]) {
    return PAGE_TITLES[basePath];
  }

  if (basePath && basePath.includes('/daily-roster/instructor')) {
    return 'Instructor Calendar Management';
  }
  // Fallback: capitalize the last segment
  // const lastSegment = pathSegments[pathSegments.length - 1];
  // return lastSegment
  //   ? lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1)
  //   : 'Page';
  return '';
};
